/* 08 · Trois univers (Shopify : assets/obaia-section-trois-univers.js)
   Les tuiles une par une (décalage 225 ms) ; dans chaque tuile, le titre puis « Découvrir » 300 ms après la photo. */
OBAIA.section('trois-univers', {
  anim: function (fx) {
    OBAIA.$$('[data-section="trois-univers"]').forEach(function (sec) {
      fx.rows(OBAIA.$$('.tu__tile', sec), function (tl, tile, t) {
        fx.appear(tl, tile, t);
        fx.appear(tl, OBAIA.$('.tu__title', tile), t + 0.3);
        fx.appear(tl, OBAIA.$('.lien', tile), t + 0.3 + fx.STEP);
      }, 0.225 * fx.K);
    });
  }
});
